
import { StateChanger } from 'vue-infinite-loading'
import { Vue, Component, Watch } from 'vue-property-decorator'
import { GoodsPurchase } from '@/types'
import FilterUtil from '@/filter-util'
import CSVExport from '@/components/CSVExport.vue'
import DateSelect from '@/components/DateSelect.vue'

// CSVHeaders sẽ được tạo trong computed để sử dụng i18n

const filterUtil = new FilterUtil({
  // search: { type: String, default: null },
  ordering: { type: String, default: '' },
  dateFrom: { type: String, default: null },
  dateTo: { type: String, default: null },
  shop: { type: String, default: null },
})

@Component({
  components: { CSVExport, DateSelect },
})
export default class GoodsPurchaseListPage extends Vue {
  items: GoodsPurchase[] = []
  totalCount = 0
  next: null | string = null
  query: Record<string, any> = {}
  filter = {
    // search: null,
    ordering: '',
    dateFrom: null,
    dateTo: null,
    shop: null,
  }
  get identifier() {
    return JSON.stringify(this.query)
  }
  get fetchParams() {
    let params = {}
    if (this.query) Object.assign(params, this.query)

    return params
  }
  get csvHeaders() {
    const t = this.$t.bind(this)
    return [
      { key: 'id', label: 'id' },
      { key: 'date', label: t('goods.text.date') },
      { key: 'shopCode', label: t('goods.text.shopCode') },
      { key: 'shopName', label: t('goods.text.shopName') },
      { key: 'goods', label: t('goods.csv.goodsId') },
      { key: 'goodsName', label: t('goods.csv.goods') },
      { key: 'unitPrice', label: t('goods.text.unitPrice') },
      { key: 'quantity', label: t('goods.text.quantity') },
      { key: 'customerCode', label: t('goods.text.customerCode') },
      { key: 'customerName', label: t('goods.text.customer') },
    ]
  }

  @Watch('$route.query', { immediate: true })
  onRouteQueryChanged(query: any) {
    this.query = filterUtil.parseQueryDict(query)
  }

  @Watch('identifier')
  onIdentifierChanged() {
    this.items = []
    this.next = null
    this.getTotalCount()
  }

  created() {
    Object.assign(this.filter, this.query)
    this.getTotalCount()
  }

  async getTotalCount() {
    this.totalCount = await this.$api
      .purchaseHistories()
      .count(this.fetchParams)
  }

  async fetchData($state: StateChanger) {
    try {
      let { results, next } = await (this.next
        ? this.$api.http.get(this.next)
        : this.$api.purchaseHistories().list(this.fetchParams))
      this.items = this.items.concat(results)
      this.next = next
      if (this.items.length) $state.loaded()
      if (!this.next) $state.complete()
    } catch (err) {
      $state.error()
    }
  }

  updateQuery() {
    let query = filterUtil.mergeQueryDict(this.query, this.filter)
    this.$router.push({ query })
  }
}
